import { render, staticRenderFns } from "./ListPatientMedecinControl.vue?vue&type=template&id=f2ba7538&scoped=true"
import script from "./ListPatientMedecinControl.vue?vue&type=script&lang=js"
export * from "./ListPatientMedecinControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ba7538",
  null
  
)

export default component.exports